
$('.flashe-product').slick({
    dots: false,
    infinite: false,
    speed: 600,
    arrows: true,
    slidesToShow: 5,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev">Next</button>',
    nextArrow: '<button type="button" class="slick-next">Pre</button>',
    responsive: [{
            breakpoint: 1440,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: false,
                dots: false
            }
        },{
            breakpoint: 1259,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                dots: false
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                dots: false
            }
        }, 
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});


$('.sear-section .serch-innerass').on('click', function(){

    $('.sear-section').toggleClass('show-searches');
});



$(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 1) {
        $(".announcement-bar-new").addClass("anna-scroll");
    } else {
        $(".announcement-bar-new").removeClass("anna-scroll");
    }
});

 


$('.toggle').click(function(e) {
    $(this).next('.dropdown-menu ').slideToggle(500);
    $(this).parent('li').siblings().children('.dropdown-menu').slideUp(500);
 
 });
 


//  $('.order-isue-select > option').each(function(){
//     $('#order-number-id').addClass($(this).val());
// });


// $('.order-isue-select > option').each(function(){
//     var theText = $(this).html();
//     $('#order-number-id').addClass(theText);
// });


$(".order-isue-select").change(function(){
    if($(this).val() == "Order Issue") {
       $('#order-number-id').addClass('order-hides');
       $("#order-number-id input").prop('required',true);


    } else {
       $('#order-number-id').removeClass('order-hides');
    }
});


$(".toggle-text-link").click(function(event){
    event.preventDefault();
 $(this).closest('.toggle-text').toggleClass('active');
});